import {
    Button,
    CircularProgress,
    IconButton,
    TextField,
    Tooltip,
    Typography,
    } from "../../ui";
import React,
    { useEffect,
    useState } from "react";
import { useDispatch,
    useSelector } from "react-redux";
import {
  CART_INITIAL_STATE,
  GET_CUSTOMER_DETAIS,
  getPreUrlAccordingToCart,
  InternalBillType,
  SUCCESS
} from "../../../constants/constant";
import { INITIALROOMDETAIS } from "./RestBillConstants";
import { isEmpty } from "lodash";
import axios from "axios";
import AddCustomerDetailsDialog from "./AddCustomerDetailsDialog";
import { updateBillCustomerDetails } from "../../../store/billDetailsSlice";
import { getConfigValueByKey } from "../../../utilities/commonUtilities";
import HotelRoomSearchDialog from "./HotelRoomSearchDialog";
import { Edit } from "../../ui/icons";

function CustomerDetails() {
  const [hotelRoomDialog, setHotelRoomDialog] = useState(false);
  const [hotelDialogLoader, setHotelDialogLoader] = useState(false);
  const [isMobileAdded, setisMobileAdded] = useState(false);
  const [roomDetails, setRoomDetails] = useState(INITIALROOMDETAIS);
  const [customerDetails, setCustomerDetails] = useState({});
  const [customerInputDialog, setCustomerInputDialog] = useState({
    custInputopen: false,
    custInputAdd: false, // why? it will be add button right?
    redeemRoyaltyPrice: false,
    getRoyaltyDiscount: false,
    amtPaid: "",
  });
  const [custMob, setCustMob] = useState("");
  const [isCustomerAdded, setisCustomerAdded] = useState(false);
  const [showCustomerAddDialog, setShowCustomerAddDialog] = useState(false);
  const { billDetails, billCustomerDetails, billHotelDetails } = useSelector(
    (state) => state.bill
  );
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash
  );
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );

  const restoBillConfig = useSelector((state) => state.restoBillConfig);
  const dispatch = useDispatch();

  const [isCustLoading, setCustLoading] = useState(false);

  useEffect(() => {
    if (billCustomerDetails && !isEmpty(billCustomerDetails.custMob)) {
      setisCustomerAdded(true);
      setisMobileAdded(true);
    }
    console.log("customerInfoAdded; ", isCustomerAdded, billCustomerDetails);
  }, [billCustomerDetails]);

  useEffect(() => {
    //console.log("hotelRoomDialog", hotelRoomDialog);
    //Loading billing details
  }, [billDetails]);

  useEffect(() => {
    console.log("hotelRoomDialog", hotelRoomDialog);
  }, [hotelRoomDialog]);
  const getTableName = () => {
    let data = billDetails.tableNo;
    if (billDetails.tableName)
      data =
        "Table: " + billDetails.tableName + "(" + billDetails.tableNo + ")";
    else data = "Table No: " + billDetails.tableNo + "";
    return data;
  };

  const handleMobileInputChange = (e) => {
    setCustMob(e.target.value);
    if (e.target.value.length === 10) {
      getCustomerData(e.target.value);
    } else {
      dispatch(
        updateBillCustomerDetails({
          ...billCustomerDetails,
          custId: "",
          custMob: "",
          custName: "",
          custEmail: "",
          address: "",
        })
      );
      setisCustomerAdded(false);
    }
  };

  const getCustomerData = (mobileNo) => {
    console.log("checking customer data");
    setisMobileAdded(true);
    let custgUrl =
      storeApiUrl.BACKEND_BASE_URL +
      getPreUrlAccordingToCart(storeActiveShopHash.cartType) +
      GET_CUSTOMER_DETAIS;

    let data = {
      jcJson: {
        apiToken: CART_INITIAL_STATE.apiToken,
        shopHash: storeActiveShopHash.id,
        custMob: mobileNo,
      },
    };
    // test mob: 2345678900
    axios
      .post(custgUrl, data)
      .then((response) => {
        if (response.data.status !== SUCCESS) {
          setCustomerDetails({
            ...customerDetails,
            custId: "",
            custMob: "",
            custName: "",
            custEmail: "",
            address: "",
          });
          dispatch(
            updateBillCustomerDetails({
              ...billCustomerDetails,
              custId: "",
              custMob: "",
              custName: "",
              custEmail: "",
              address: "",
            })
          );
          console.log("cust not found....");

          throw new Error("Customer Data Not Found!!");
        }
        let jcJson = response.data.jcJson;
        // //printLog("getCustomer",jcJson);
        // why are we doing it?
        // setBillingData({
        //   ...billCustomerDetails,
        //   ...jcJson,
        //   pointRedeem: jcJson.royalityPoint,
        // });
        console.log("cust found....");
        setCustomerDetails({
          ...customerDetails,
          pointRedeem: jcJson.royalityPoint,
        });

        dispatch(
          updateBillCustomerDetails({
            ...billCustomerDetails,
            custId: jcJson.custId,
            custMob: mobileNo,
            custName: jcJson.custName,
            custEmail: jcJson.custEmail,
            address: jcJson.address,
          })
        );
        setCustomerInputDialog({
          ...customerInputDialog,
          custInputAdd: true,
          redeemRoyaltyPrice: jcJson.royalityPoint > 0,
        });
        setisCustomerAdded(true);
        //setisMobileAdded(true); // why false utla hai check kya??
        //e.target.value = "";
      })
      .catch((error) => {
        // e.target.value = "";
        console.log(" error cust not found....");
        //setisMobileAdded(tr);
        setisCustomerAdded(false);
        //printLog(error);
      })
      .finally(() => {
        setCustLoading(false);
      });
  };

  const renderShopDetails = () => {
    const { shop, gstDetail, location } = storeActiveShopHash;
    //const hotelSale = getConfigValueByKey(restoBillConfig, HOTELSALES);
    const hotelSale = true;
    const showRoomButton =
      hotelSale && billDetails.billingType !== InternalBillType.Home;

    return (
      <div className="billing-data-container">
        <Typography variant="p" component="div" className="shop-details">
          Paid To :
        </Typography>
        <Typography
          variant="p"
          component="div"
          className="shop-name"
          style={{
            color: "#2f1160",
            whiteSpace: "pre-wrap",
            overflowWrap: "break-word",
            fontSize: shop.length > 20 ? "12px" : "16px",
          }}
        >
          {shop}{" "}
        </Typography>
        { showRoomButton && (
          <Button
            size="small"
            variant="contained"
            disabled={billDetails.isPaid}
            color="primary"
            onClick={() => setHotelRoomDialog(true)}
          >
            {isEmpty(billHotelDetails.hotelBillNo)
              ? "Search Room"
              : `Room No : ${billHotelDetails.hotelBillNo}`}
          </Button>
        )}
        <Typography
          variant="p"
          component="div"
          className="shop-details shop-gst"
        >
          {gstDetail}{" "}
        </Typography>
        {billDetails.tableId && (
          <Typography
            variant="p"
            component="div"
            className="shop-details table-no"
          >
            {getTableName()}{" "}
          </Typography>
        )}
        {/* {renderDialogHotelRoom()} */}
      </div>
    );
  };

  return (
    <div>
      <div className="billing-data-grid-container">
        {renderShopDetails()}
        {!billDetails.isPaid && (
          <div className="billing-data-container">
            <Typography
              variant="p"
              component="div"
              className="existing-customer-search"
              style={{ marginBottom: "10px" }}
            >
              Search for Customer :
            </Typography>
            <TextField
              id="outlined-basic"
              label="Mobile Number"
              variant="filled"
              size="small"
              className="existing-customer__mobile-number"
              style={{ marginBottom: "15px" }}
              onChange={handleMobileInputChange}
              inputProps={{
                inputMode: "numeric", // For mobile keyboard
                maxLength: 10,
              }}
              disabled={isCustLoading}
            />
            {isCustLoading && (
              <CircularProgress
                color="primary"
                size={30}
                style={{ verticalAlign: "middle" }}
              />
            )}
          </div>
        )}
        {isMobileAdded && (
          <div className="billing-data-container">
            {!isCustomerAdded && (
              <Typography
                variant="p"
                component="div"
                className="existing-customer__error"
                style={{ whiteSpace: "initial" }}
              >
                Customer Not Found!! Please make a new entry.
              </Typography>
            )}
            {(isCustomerAdded ||
              (billCustomerDetails && billCustomerDetails.custMob !== "")) && (
              <div className="customer-details-container " style={{ position: "relative" }}>
                {!billDetails.isPaid && (
                  <div>
                    <Tooltip title="Update Customer">
                      <IconButton
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          border: "2px solid #1976d2!important", // You can change the color
                          borderRadius: "8px", // Optional: more visible rounding
                          backgroundColor: "#fff!important", // Optional: contrast background
                        }}
                        key="newCust"
                        variant="contained"
                        onClick={() => setShowCustomerAddDialog(true)}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
                <div>
                  <Typography
                    variant="p"
                    component="div"
                    className="customer-details"
                  >
                    Bill To :
                  </Typography>
                  <Typography
                    variant="p"
                    component="div"
                    className="customer-name"
                  >
                    {billCustomerDetails.custName}
                  </Typography>
                  <Typography
                    variant="p"
                    component="div"
                    className="customer-details customer-mob-num"
                  >
                    {billCustomerDetails.custMob}
                  </Typography>
                  <Typography
                    variant="p"
                    component="div"
                    className="customer-details customer-email-id"
                    style={{ whiteSpace: "initial", wordBreak: "break-word" }}
                  >
                    {billCustomerDetails.custEmail}
                  </Typography>
                </div>
              </div>
            )}
            {!isCustomerAdded && (
              <Button
                key="newCust"
                variant="contained"
                className="new-customer-entry"
                onClick={() => setShowCustomerAddDialog(true)}
              >
                Add New Customer
              </Button>
            )}
            <AddCustomerDetailsDialog
              showDialog={showCustomerAddDialog}
              setShowDialog={setShowCustomerAddDialog}
              customerMobile={custMob}
            />
          </div>
        )}
        <HotelRoomSearchDialog
          showDialog={hotelRoomDialog}
          setShowDialog={setHotelRoomDialog}
        />
      </div>
    </div>
  );
}

export default CustomerDetails;
